/**
 * i18n: Jobs hire verified-business gate — ko/en/vi/ru
 * Tuples are [ko, en, vi, ru].
 */

function pick(obj, langIndex) {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (Array.isArray(v) && v.length >= 4) out[k] = v[langIndex];
    else if (v && typeof v === 'object' && !Array.isArray(v)) out[k] = pick(v, langIndex);
    else out[k] = v;
  }
  return out;
}

const hireGate = {
  selectBusiness: [
    '채용 업체 (사업자 인증)',
    'Hiring business (verified)',
    'Doanh nghiệp tuyển dụng (đã xác minh)',
    'Бизнес для найма (верифицирован)',
  ],
  selectPlaceholder: [
    '인증된 업체를 선택하세요',
    'Select a verified business',
    'Chọn doanh nghiệp đã xác minh',
    'Выберите верифицированный бизнес',
  ],
  needVerified: [
    '구인 공고는 사업자 인증된 업체로만 등록할 수 있어요.',
    'Hire posts require a verified business.',
    'Tin tuyển dụng chỉ đăng được với doanh nghiệp đã xác minh.',
    'Вакансии можно публиковать только от верифицированного бизнеса.',
  ],
  needBusiness: [
    '먼저 업체를 등록한 뒤 사업자 인증을 받아 주세요.',
    'Register a business and get it verified first.',
    'Hãy đăng ký doanh nghiệp và xác minh trước.',
    'Сначала зарегистрируйте бизнес и пройдите верификацию.',
  ],
  goDashboard: [
    '업체 대시보드로 이동',
    'Go to business dashboard',
    'Đến bảng điều khiển doanh nghiệp',
    'В кабинет бизнеса',
  ],
  pickTitle: [
    '어느 업체로 구인할까요?',
    'Which business is hiring?',
    'Tuyển dụng cho doanh nghiệp nào?',
    'От какого бизнеса публикуем?',
  ],
  companyLockedHint: [
    '상호명은 선택한 인증 업체명으로 자동 입력됩니다.',
    'Company name is filled from the verified business you select.',
    'Tên công ty được điền từ doanh nghiệp đã xác minh bạn chọn.',
    'Название компании подставляется из выбранного верифицированного бизнеса.',
  ],
  errors: {
    BUSINESS_REQUIRED: [
      '인증된 업체를 선택해 주세요.',
      'Please select a verified business.',
      'Hãy chọn doanh nghiệp đã xác minh.',
      'Выберите верифицированный бизнес.',
    ],
    BUSINESS_NOT_VERIFIED: [
      '선택한 업체가 아직 사업자 인증되지 않았어요.',
      'That business is not verified yet.',
      'Doanh nghiệp đó chưa được xác minh.',
      'Этот бизнес ещё не верифицирован.',
    ],
    BUSINESS_NOT_OWNED: [
      '본인 소유의 업체만 구인 공고를 올릴 수 있어요.',
      'You can only post hire jobs for businesses you own.',
      'Chỉ đăng tin tuyển dụng cho doanh nghiệp bạn sở hữu.',
      'Публиковать вакансии можно только от своих бизнесов.',
    ],
    BUSINESS_NOT_FOUND: [
      '업체를 찾을 수 없어요.',
      'Business not found.',
      'Không tìm thấy doanh nghiệp.',
      'Бизнес не найден.',
    ],
  },
};

const jobsBusinessDash = {
  hiringRoomTitle: ['채용 관리', 'Hiring desk', 'Quản lý tuyển dụng', 'Кабинет найма'],
  verifyRequired: [
    '사업자 인증 후에 구인 공고를 등록할 수 있어요.',
    'Verify your business license to post hire jobs.',
    'Xác minh giấy phép kinh doanh để đăng tin tuyển dụng.',
    'Пройдите верификацию бизнеса, чтобы публиковать вакансии.',
  ],
  verifyHint: [
    '운영팀이 사업자등록증을 확인하면 인증 마크가 표시됩니다. 문의는 고객센터로 연락해 주세요.',
    'Once our team verifies your business license, a badge appears. Contact support if you need help.',
    'Sau khi đội vận hành xác minh giấy phép, huy hiệu sẽ hiện. Liên hệ hỗ trợ nếu cần.',
    'После проверки лицензии командой появится значок. При необходимости обратитесь в поддержку.',
  ],
};

function buildLang(langIndex) {
  return {
    jobs: {
      hireGate: pick(hireGate, langIndex),
    },
    dashboard: {
      jobsBusiness: pick(jobsBusinessDash, langIndex),
    },
  };
}

export const phaseJobsHireGateKo = buildLang(0);
export const phaseJobsHireGateEn = buildLang(1);
export const phaseJobsHireGateVi = buildLang(2);
export const phaseJobsHireGateRu = buildLang(3);
